import { FC } from 'react';
import { renderIcon } from './icons';

interface Props {
  icon: string;
  svgClassName?: string;
}

// -----------------------------------------------------------------------------
const SpriteIcon: FC<Props> = props => {
  const { icon, svgClassName } = props;
  return renderIcon(icon, svgClassName ? { className: svgClassName } : {});
};

export default SpriteIcon;
